module.exports = __webpack_public_path__ + "assets/img/right-title-open-30bfec93.png";